<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <!-- <a @click="$router.go(-1)" class="headerButton" style="cursor:pointer;">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </a> -->
                <router-link
                    :to="{
                        name: 'home',
                    }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">
                {{
                    selectCategory.length > 0
                        ? selectCategory[0].product_name
                        : 'Loading...'
                }}
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Form -->
            <div class="section inset mt-2">
                <div class="form-group boxed p-0 mb-2">
                    <div class="input-wrapper">
                        <label class="label">Nomor Telepon</label>
                        <input
                            type="number"
                            class="form-control form-control-lg"
                            v-model="data_order.destination"
                        />
                        <i class="clear-input">
                            <ion-icon
                                name="close-circle"
                                @click="clearDestination()"
                            ></ion-icon>
                        </i>
                        <!-- <ButtonLoader
              :loading="loading.button_check_pln"
              :styled="'custom-botton-inside btn-primary'"
              :type_loader="'spin'"
              @click.native="checkPLN()"
              v-if="$route.params.id == 5"
              >Cek</ButtonLoader
            > -->
                    </div>

                    <div class="mt-1">
                        <div
                            class="chip chip-media"
                            style="font-size: 11px; background: #efefef"
                            @click="openPhoneBook()"
                        >
                            <i class="chip-icon bg-primary">
                                <ion-icon name="journal-outline"></ion-icon>
                            </i>
                            <span class="chip-label">Kontak</span>
                        </div>
                        <div
                            class="chip chip-media ml-1"
                            style="font-size: 11px; background: #efefef"
                            @click="phone(customer.phone)"
                        >
                            <i class="chip-icon bg-primary">
                                <ion-icon name="call-outline"></ion-icon>
                            </i>
                            <span class="chip-label">{{ customer.phone }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- List Operator -->
            <div class="section mt-1">
                <div
                    class="section-heading padding mt-3 mb-2 pl-0"
                    v-if="!loading.content"
                >
                    <h2 class="title" style="font-size: 15px">
                        Pilihan Produk
                    </h2>
                </div>

                <div class="text-center" v-if="loading.list_operator">
                    <span
                        class="spinner-border spinner-border-sm mr-1"
                        role="status"
                        aria-hidden="true"
                    ></span>
                </div>

                <div class="transactions" v-else-if="operator.length > 0">
                    <!-- item -->
                    <a
                        href="javascript:;"
                        class="item"
                        v-for="itemOperator in operator"
                        :key="itemOperator.id"
                        style="padding: 10px"
                        @click="selectOperator(itemOperator)"
                    >
                        <div class="detail">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    itemOperator.icon
                                        ? VUE_ENV.VUE_APP_ASSET_URL +
                                          '/img/icon/operator/' +
                                          itemOperator.icon
                                        : require('@/assets/Loader-2.png')
                                "
                                alt="image"
                                class="image-block imaged"
                                style="width: 30px"
                            />
                            <div style="color: #17273e">
                                <b>{{ itemOperator.product_name }}</b>
                                <footer>
                                    <small>{{
                                        itemOperator.description
                                    }}</small>
                                </footer>
                            </div>
                        </div>

                        <div class="right">
                            <div class="icon">
                                <ion-icon
                                    name="chevron-forward-outline"
                                ></ion-icon>
                            </div>
                        </div>
                    </a>
                    <!-- * item -->
                </div>

                <div class="text-center mt-1" v-else-if="!loading.content">
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="empty"
                        style="width: 65%"
                    /><br />
                    <h2 class="mb-0">Belum Ada Data</h2>
                    <p>Tidak ada data yang dapat ditampilkan</p>
                </div>
            </div>
        </div>

        <!-- Modal Status Pembelian  -->
        <action-sheet ref="status" :title="'Status Pembelian'" :inset="true">
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Pembayaran Berhasil</h3>
                <p>Transaksi Anda sedang diproses</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="directToHistory()"
                >
                    Lihat Riwayat Transaksi
                </button>
                <button
                    class="btn btn-outline-primary btn-block btn-lg"
                    @click="hideStatus"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>

        <Dialog
            ref="dialog_update_apk"
            :loading="false"
            :title="'Update Aplikasi'"
            @confirm="updateApk()"
        >
            Aplikasi versi terbaru telah tersedia di playstore. Update Sekarang!
        </Dialog>
    </div>
</template>
<script>
    import $axios from './../../../../api.js';
    import { mapState, mapMutations } from 'vuex';
    export default {
        props: ['redirect', 'operator_data', 'toast_reference'],
        data() {
            return {
                loading: {
                    content: true,
                    list_operator: false,
                },
                operator: [],
                time: null,
            };
        },
        created() {
            this.getOperator();
            // window.fbq("track", "ViewContent");
        },
        computed: {
            ...mapState([
                'customer',
                'toast',
                'VUE_ENV',
                'device',
                'categoryPrabayar',
            ]),
            ...mapState('transactionPrabayar', {
                data_order: state => state.data_order,
            }),
            selectCategory() {
                return this.categoryPrabayar.filter(item => {
                    return item.id == this.$route.params.id;
                });
            },
        },
        methods: {
            ...mapMutations('transactionPrabayar', ['RESET_DATA_ORDER']),
            clearDestination() {
                if (this.data_order.destination != '') {
                    this.data_order.destination = '';
                    this.loading.list_operator = true;
                    this.getPrefix();
                }
            },
            updateApk() {
                this.dialogUpdateAPK('hide');
                window.open(
                    'https://play.google.com/store/apps/details?id=com.digifazz.app',
                    '_blank'
                );
            },
            dialogUpdateAPK(value) {
                let element = this.$refs.dialog_update_apk.$el;
                window.$(element).modal(value);
            },
            inAppReview() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.inAppReview();
                }
            },
            phone(phone) {
                this.data_order.destination = this.$options.filters.filterPhone(
                    this.$options.filters.filterPhone(
                        phone.substring(0, 3),
                        ['+62', '62'],
                        ['0', '0']
                    ) + phone.substring(20, 3),
                    ['-'],
                    ['']
                );
                if (this.withPrefix == 1) {
                    this.getPrefix();
                }
            },
            selectOperator(data) {
                if (this.data_order.destination == '') {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: 'Nomor Telepon harus diisi',
                        tipe: 'default',
                        icon: 'danger',
                    });
                } else {
                    this.$router.push({
                        name: 'prabayar-with-prefix-order',
                        params: {
                            id: data.id,
                            operator_selected: data,
                            destination: this.data_order.destination,
                        },
                    });
                }
            },
            getPrefix() {
                this.$store.commit('RESET_TOAST');
                this.data_order.destination = this.$options.filters.filterPhone(
                    this.$options.filters.filterPhone(
                        this.data_order.destination.substring(0, 3),
                        ['+62', '62'],
                        ['0', '0']
                    ) + this.data_order.destination.substring(20, 3),
                    ['-'],
                    ['']
                );

                if (this.data_order.destination.length >= 4) {
                    if (this.time) {
                        clearTimeout(this.time);
                    }
                    this.time = setTimeout(() => {
                        this.loading.list_operator = true;
                        this.getOperator();
                    }, 500);
                } else {
                    this.data = {
                        destination: this.data_order.destination,
                        operator_id: '',
                        operator_icon: '',
                        operator_description: '',
                        product_id: '',
                        product_name: '',
                        price: '',
                    };
                }
            },
            getOperator() {
                this.operator = [];
                $axios
                    .post('/prabayar/operator', {
                        category_id: this.$route.params.id,
                        prefix: this.data_order.destination.substring(0, 4),
                    })
                    .then(response => {
                        if (response.data.data.length > 0) {
                            this.operator = response.data.data;
                            this.loading.list_operator = false;
                            this.loading.content = false;
                        } else {
                            this.operator = [];
                            // this.$store.commit("SET_TOAST", {
                            //   show: true,
                            //   message: "Produk belum tersedia",
                            //   tipe: "default",
                            // });
                            this.loading.list_operator = false;
                            this.loading.content = false;
                        }
                    })
                    .catch(e => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: e.response.data.message,
                            tipe: 'default',
                        });
                        this.loading.list_operator = false;
                        this.loading.content = false;
                    });
            },
            openPhoneBook() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.openPhoneBook();
                }
            },
            showStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('show');
            },
            hideStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('hide');
                this.inAppReview();
            },
            directToHistory() {
                this.hideStatus();
                this.$router.push({
                    name: 'transaction.index',
                });
            },
        },
        watch: {
            'data_order.destination': function () {
                if (this.data_order.destination != '') {
                    this.getPrefix();
                } else {
                    this.getOperator();
                }
            },
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.showStatus();
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);

            window['phone'] = phone => {
                this.phone(phone);
            };
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
            this.RESET_DATA_ORDER();
        },
        filters: {
            filterPhone: function (value, findArray, replaceArray) {
                var i,
                    regex = [],
                    map = {};
                for (i = 0; i < findArray.length; i++) {
                    regex.push(
                        findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1')
                    );
                    map[findArray[i]] = replaceArray[i];
                }
                regex = regex.join('|');
                var destination = value.replace(
                    new RegExp(regex, 'g'),
                    function (matched) {
                        return map[matched];
                    }
                );
                return destination.replace(/ /g, '');
            },
            inputRupiah: function (value) {
                value = value.toString();
                var number_string = value.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah =
                    split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return rupiah;
            },
        },
    };
</script>
